import { render, staticRenderFns } from "./CostFunc.vue?vue&type=template&id=bc250d64&"
import script from "./CostFunc.vue?vue&type=script&lang=js&"
export * from "./CostFunc.vue?vue&type=script&lang=js&"
import style0 from "./CostFunc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports